import React from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {getZoom} from "../../reducers/project/selectors";
import {ProjectActions} from "../../reducers/project/actionsNames";
import ToolbarItem from "./ToolbarItem";
import {FilterCenterFocus, RotateLeft, ZoomIn, ZoomOut,} from "@material-ui/icons";

const Wrapper = styled.div`
  display: flex;
  z-index: 30000;
  margin-top: -60px;
  margin-bottom: 20px;
  justify-content: center;
  position: relative;
  user-select: none;
`;

function Toolbar({}: IToolbar) {
    const zoom = useSelector(getZoom);

    const dispatch = useDispatch();

    const handleZoom = (z: number) => () => {
        if ((z === -1 && zoom > 1) || (z === 1 && zoom <= 4)) {
            dispatch({ type: ProjectActions.SetZoom, zoom: zoom + z });
        }
    };

    const resetZoom = () => dispatch({ type: ProjectActions.SetZoom, zoom: 1 });
    const center = () => dispatch({ type: ProjectActions.Center });

    return (
        <Wrapper>
            <ToolbarItem onClick={handleZoom(1)} Icon={<ZoomIn />} />
            <ToolbarItem onClick={handleZoom(-1)} Icon={<ZoomOut />} />
            <ToolbarItem onClick={center} Icon={<FilterCenterFocus />} />

            <ToolbarItem onClick={resetZoom} Icon={<RotateLeft />} />
        </Wrapper>
    );
}

export interface IToolbar {}

export default Toolbar;
